// extracted by mini-css-extract-plugin
module.exports = {"verificationCodeContainer":"verification-code_verificationCodeContainer___f_cS","label":"verification-code_label__qmcNA","grid":"verification-code_grid__9St4D"};